// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","791":"2d0c6a1e","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"2cb5503eec5b213cb353","532":"da52a24ad2f345e15fa0","678":"ef14d7a821320839a131","791":"be484aaade19a183a674","883":"edf95c1cd878d8778f71"}[chunkId] + ".js";
};